import { forwardRef, useCallback } from 'react';
import { AgNumericInput, type AgNumericInputProps } from './AgNumericInput';

export interface AgMoneyInputProps
  extends Omit<AgNumericInputProps, 'value' | 'onChange' | 'startContent' | 'decimalScale' | 'thousandSeparator'> {
  /** Value in cents (integer). null means empty. */
  value: number | null;
  /** Called with value in cents, or null if cleared */
  onChange: (cents: number | null) => void;
}

export const AgMoneyInput = forwardRef<HTMLInputElement, AgMoneyInputProps>(({ value, onChange, ...props }, ref) => {
  const displayValue = value != null ? value / 100 : null;

  const handleChange = useCallback(
    (dollars: number | null) => {
      onChange(dollars != null ? Math.round(dollars * 100) : null);
    },
    [onChange]
  );

  return (
    <AgNumericInput
      ref={ref}
      value={displayValue}
      onChange={handleChange}
      startContent="$"
      decimalScale={2}
      thousandSeparator
      {...props}
    />
  );
});

AgMoneyInput.displayName = 'AgMoneyInput';
